<template>
  <div class="content-holder">
    <div class="pamm-content wow fadeIn">
      <div class="title-holder" >
        <h4>{{$t("pamm_acct.title")}}</h4>
        <p>{{$t("pamm_acct.description_one")}}</p>
        <br />
        {{$t("pamm_acct.description_two")}}
      </div>
    </div>
    <div class="pamm-manager wow fadeInLeft" data-wow-delay="0.3s">
      <h3>{{$t("pamm_acct.sub_title")}}</h3>
      <ul>
        <li>{{$t("pamm_acct.sub_Point_one")}}</li>
        <li>{{$t("pamm_acct.sub_Point_two")}}</li>
        <li>{{$t("pamm_acct.sub_Point_three")}}
          <a href="mailto:contactus@aaafx.com">contactus@aaafx.com</a>.
        </li>
        <li>{{$t("pamm_acct.sub_Point_four")}}</li>
      </ul>
    </div>
    <div class="pamm-benefits wow fadeInRight" data-wow-delay="0.3s">
      <div class="benefits">
        <p class="center-div">{{$t("pamm_acct.minimul_investment")}}</p>
      </div>
      <div class="benefits">
        <p class="center-div">{{$t("pamm_acct.ease_of_access")}}</p>
      </div>
      <div class="benefits">
        <p class="center-div">{{$t("pamm_acct.ultimate_trading_conditions")}}</p>
      </div>
      <div class="benefits">
        <p class="center-div">{{$t("pamm_acct.trade_security")}}</p>
      </div>
    </div>
    <div class="btn-holder" style="margin-left: 65px;"><!--  t-center -->
      <router-link :to="{name : 'Support',query:{'from':'pamm-acct'}}" class="btn btn-yellow">{{$t("pamm_acct.request_pamm")}}</router-link>
    </div>
  </div>
</template>
